module.exports = __webpack_public_path__ + "img/hero-dots-2.7b771e00.png";